"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddCartItemDto = exports.UpdateCartItemDto = exports.BaseCartItemDto = exports.CartItemDto = exports.CartDiscountDto = exports.CartTaxDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
class CartTaxDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.CartTaxDto = CartTaxDto;
class CartDiscountDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.CartDiscountDto = CartDiscountDto;
class CartItemDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.CartItemDto = CartItemDto;
class BaseCartItemDto {
    constructor(baseCartItem) {
        this.quantity = baseCartItem === null || baseCartItem === void 0 ? void 0 : baseCartItem.quantity;
        this.userId = baseCartItem === null || baseCartItem === void 0 ? void 0 : baseCartItem.userId;
        this.resources = baseCartItem === null || baseCartItem === void 0 ? void 0 : baseCartItem.resources;
    }
}
exports.BaseCartItemDto = BaseCartItemDto;
class UpdateCartItemDto extends BaseCartItemDto {
    constructor(updateCartItem) {
        super(updateCartItem);
        this.id = updateCartItem === null || updateCartItem === void 0 ? void 0 : updateCartItem.id;
    }
}
exports.UpdateCartItemDto = UpdateCartItemDto;
class AddCartItemDto extends BaseCartItemDto {
}
exports.AddCartItemDto = AddCartItemDto;
//# sourceMappingURL=cart-item.dto.js.map